export default __webpack_public_path__ + "static/media/mastercard.1fc90028.svg";